/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';

const Logger = require('../logger');
const AbstractMessageHandler = require('./abstract_message_handler');

class MessageHandlerModal extends AbstractMessageHandler {

  get MESSAGE_EVENT() {
    return 'modal';
  }

  handleMessage(message) {
    if (message.data.src.match(/^\/{1}[^\/]+/)) {
      message.data.src = '//' + this.window.location.host + message.data.src;
      message.data.src = message.data.src.replace('{session_id}', this.window.Emarsys.config.session_id);
    }
    Logger.sendLog('modal called', { src: message.data.src });

    this.window.Emarsys.integration.dialog.modal(message);
  }

}

module.exports = MessageHandlerModal;




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./message_handler/modal.js
 **/